export default "__VITE_ASSET__DTRXBzLJ__"